import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })

export class StyleManager {

  toggleTheme(color?: string) {
    if (!color) {
      color = localStorage.getItem('color') || 'light';
    }
    localStorage.setItem('color', color);
    this.loadStyle(`css/themes/${color}/${color}-theme.css`);
  }


  loadStyle(styleName: string) {
    const head = document.getElementsByTagName('head')[0];

    let themeLink = document.getElementById(
      'themeStyle'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = `assets/${styleName}`; //<--add assets
    } else {
      const style = document.createElement('link');
      style.id = 'themeStyle';
      style.rel = 'stylesheet';
      // style.type = 'text/css';
      style.href = `assets/${styleName}`; //<--add assets

      head.appendChild(style);
    }
  }
}
